import React, { Component } from "react";
// import Textarea from "react-textarea-autosize";

// Components
import Modal from "../../modal/Modal";
import Button from "../../modal/Button";
import Loader from "../Loader";
import ErrorText from "../error-success/ErrorText";

// CKeditor
import CKEditor from "react-ckeditor-component";
import { editorReady } from "../../../utils/editor";
import CKEditorInput from "../../../utils/forms/CKEditorInput";

// Utils
import {
	handleKeyPress,
	handleInputChange,
	editorChange,
	handleCheckboxClick
} from "../../../utils/forms/inputHandling";

const initialState = {
	question: "",
	answer: "",
	restricted: 0
};

class AddNewFaqDialog extends Component {
	constructor(props) {
		super(props);

		this.state = {
			data: {
				...initialState
			}
		};

		this.CKEditorInput = new CKEditorInput();
	}

	/*
	 * Only update when the dialog is shown
	 */
	shouldComponentUpdate(props) {
		if (!props.show && !this.props.show) return false;
		return true;
	}

	/*
	 * Need to clear out the current title when the dialog closes
	 */
	static getDerivedStateFromProps(props, state) {
		if (props.show === false) {
			return {
				data: {
					...initialState
				}
			};
		}
		return state;
	}

	render() {
		const { errors } = this.props;

		// Only need one set of buttons because we will close this dialog upon success
		const buttons = [
			{
				type: Button,
				text: "Cancel",
				action: () => this.props.handleClose(),
				disabled: this.props.inProgress
			},
			{
				type: Button,
				text: "Add",
				action: () =>
					this.props.handleAdd({
						question: this.state.data.question,
						answer: this.state.data.answer,
						restricted: this.state.data.restricted
					}),
				disabled: this.props.inProgress
			}
		];

		return this.props.show ? (
			<Modal title={"Add New FAQ"} buttons={buttons}>
				{/* Loading */}
				{this.props.inProgress ? (
					<div className="pt2 pb2">
						<Loader />
					</div>
				) : (
					<div>
						<div className="mb2">
							Question:
							<div className="form-field">
								<input
									autoFocus
									type="text"
									id="question"
									value={this.state.data.question}
									onChange={e => this.setState(handleInputChange(e, this.state))}
									onKeyPress={e =>
										handleKeyPress(e, this.props.handleAdd, {
											question: this.state.data.question,
											answer: this.state.data.answer,
											restricted: this.state.data.restricted
										})
									}
								/>
							</div>
						</div>
						<div className="mb2">
							Answer:
							<div className="form-field">
								<CKEditor
									scriptUrl="/ckeditor/ckeditor.js"
									content={this.state.data.answer}
									config={{
										filebrowserBrowseUrl: "/file-browser",
										uploadUrl: process.env.REACT_APP_API_URL + `files`
									}}
									events={{
										instanceReady: editorReady.bind(this),
										change: e =>
											editorChange("answer", e, this.state).then(res =>
												this.setState(res)
											)
									}}
									ref={instance => {
										this.CKEditorInput.addEditor("answer", instance);
									}}
								/>
							</div>
						</div>
						<div className="mb2">
							<div className="form-field pt0">
								<div
									className={`custom-label checkbox-label${
										this.props.inProgress ? " disabled-label" : ""
									}`}
								>
									<input
										type="checkbox"
										id="restricted"
										value="1"
										checked={this.state.data.restricted}
										disabled={this.props.inProgress}
										onChange={e => {
											handleCheckboxClick(e, this.state).then(res =>
												this.setState(res)
											);
										}}
									/>
									<label htmlFor="restricted">Restricted</label>
								</div>
							</div>
						</div>
						{errors && <ErrorText errors={errors} animate={1} />}
					</div>
				)}
			</Modal>
		) : null;
	}
}

export default AddNewFaqDialog;



// WEBPACK FOOTER //
// ./src/components/utils/dialogs/AddNewFaqDialog.js